<section class="content-section">
  <div style="margin-bottom: 24px; display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center; gap: 12px;">
    <a [routerLink]="'/trajet/lister'" class="btn btn-secondary" style="display: inline-flex; align-items: center; gap: 8px;">
      ← Retour à la liste
    </a>
    <div class="mode-badge" [class.view]="!estModeEdition && trajetZonesForm.value.id" [class.edit]="estModeEdition || !trajetZonesForm.value.id">
      <span>{{ (!estModeEdition && trajetZonesForm.value.id) ? '🔒 MODE LECTURE' : '✏️ MODE ÉDITION' }}</span>
    </div>
  </div>

  <!-- VIEW MODE: Read-only display -->
  <ng-container *ngIf="!estModeEdition && trajetZonesForm.value.id">
    <div class="view-mode-container">
      <div class="form-section">
        <h3 class="form-section-title">Définir le trajet</h3>
        <div class="view-item-row">
          <div class="view-item">
            <label class="view-label">Zone de Départ</label>
            <p class="view-value">{{ trajetZonesForm.get('zoneDepartNom')?.value }}</p>
          </div>
          <div class="view-item">
            <label class="view-label">Zone d'Arrivée</label>
            <p class="view-value">{{ trajetZonesForm.get('zoneDestinationNom')?.value }}</p>
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3 class="form-section-title">Tarification</h3>
        <div class="view-item">
          <label class="view-label">Distance estimée (km)</label>
          <p class="view-value">{{ trajetZonesForm.get('distanceKm')?.value | number:'1.0-1' }} km</p>
        </div>
      </div>

      <div class="form-section" *ngIf="trajetZonesForm.get('observations')?.value">
        <h3 class="form-section-title">Observations</h3>
        <div class="view-item">
          <label class="view-label">Remarques</label>
          <p class="view-value" style="white-space: pre-wrap;">{{ trajetZonesForm.get('observations')?.value || '—' }}</p>
        </div>
      </div>

      <div class="form-actions">
        <a [routerLink]="'/trajet/lister'" class="btn btn-secondary">Retour</a>
        <button type="button" class="btn btn-primary" (click)="estModeEdition = true">Modifier</button>
      </div>
    </div>
  </ng-container>

  <!-- EDIT MODE: Form -->
  <form class="form-container" [class.edit-mode]="estModeEdition || !trajetZonesForm.value.id" [formGroup]="trajetZonesForm" (ngSubmit)="onSubmit()" *ngIf="estModeEdition || !trajetZonesForm.value.id">
    <div class="form-section" style="overflow: visible; position: relative; z-index: 10;">
      <h3 class="form-section-title">Définir le trajet</h3>
      <div class="form-row" style="overflow: visible;">

        <!-- Zone de Départ -->
        <div class="form-group" style="position: relative; overflow: visible;">
          <label class="form-label">
            Zone de Départ *
            <span style="color: var(--text-secondary); font-size: 11px; font-weight: normal; display: block; margin-top: 4px;">
              Sélectionnez la zone de départ du trajet
              <span *ngIf="searchDepart.trim(); else allDepart" style="color: var(--primary-color);">({{ zonesDepartFiltered.length }} résultat(s))</span>
              <ng-template #allDepart><span>({{ zonesOptions.length }} zone(s) disponible(s))</span></ng-template>
            </span>
          </label>

          <div style="position: relative;">
            <div
              class="form-input"
              style="cursor: pointer; display: flex; align-items: center; justify-content: space-between; padding-right: 40px;"
              (click)="toggleDropdown('depart')">
              <span [style.color]="trajetZonesForm.value.zoneDepartId ? 'var(--text-primary)' : 'var(--text-secondary)'">
                <ng-container *ngIf="trajetZonesForm.value.zoneDepartId; else placeholderDepart">
                  {{ trajetZonesForm.value.zoneDepartNom }}
                </ng-container>
                <ng-template #placeholderDepart>Sélectionner une zone de départ</ng-template>
              </span>
              <span style="color: var(--text-secondary);">▼</span>
            </div>

            <div *ngIf="showDepartDropdown"
              style="position: absolute; top: 100%; left: 0; right: 0; background: white; border: 1px solid #e0e0e0; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); z-index: 1000; margin-top: 4px; max-height: 400px; display: flex; flex-direction: column;">
              <div style="padding: 12px; border-bottom: 1px solid #e0e0e0; background: #f8f9fa;">
                <input
                  type="text"
                  class="form-input"
                  [(ngModel)]="searchDepart"
                  [ngModelOptions]="{standalone: true}"
                  (input)="filterZones('depart')"
                  (click)="$event.stopPropagation()"
                  placeholder="🔍 Rechercher une zone..."
                  style="width: 100%;">
              </div>

              <div style="overflow-y: auto; max-height: 300px;">
                <div *ngIf="zonesDepartFiltered.length === 0"
                  style="padding: 20px; text-align: center; color: var(--text-secondary);">
                  <span *ngIf="searchDepart.trim(); else noZonesDepart">Aucune zone trouvée pour "{{ searchDepart }}"</span>
                  <ng-template #noZonesDepart>Aucune zone disponible</ng-template>
                </div>
                <div *ngFor="let zone of zonesDepartFiltered"
                  class="zone-option"
                  [class.selected]="trajetZonesForm.value.zoneDepartId === zone.id"
                  (click)="selectZone('depart', zone)"
                  style="padding: 12px 16px; cursor: pointer; border-bottom: 1px solid #f0f0f0; transition: background-color 0.2s;">
                  <div style="font-weight: 600; color: #1f2937;">
                    {{ zone.nom }}
                  </div>
                  <div *ngIf="zone.description" style="font-size: 12px; color: #6b7280; margin-top: 2px;">
                    {{ zone.description }}
                  </div>
                  <span *ngIf="trajetZonesForm.value.zoneDepartId === zone.id"
                    style="float: right; color: var(--primary-color); margin-top: -20px;">✓</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Zone d'Arrivée -->
        <div class="form-group" style="position: relative; overflow: visible;">
          <label class="form-label">
            Zone d'Arrivée *
            <span style="color: var(--text-secondary); font-size: 11px; font-weight: normal; display: block; margin-top: 4px;">
              Sélectionnez la zone d'arrivée du trajet
              <span *ngIf="searchDestination.trim(); else allDest" style="color: var(--primary-color);">({{ zonesDestinationFiltered.length }} résultat(s))</span>
              <ng-template #allDest><span>({{ zonesOptions.length }} zone(s) disponible(s))</span></ng-template>
            </span>
          </label>

          <div style="position: relative;">
            <div
              class="form-input"
              style="cursor: pointer; display: flex; align-items: center; justify-content: space-between; padding-right: 40px;"
              (click)="toggleDropdown('destination')">
              <span [style.color]="trajetZonesForm.value.zoneDestinationId ? 'var(--text-primary)' : 'var(--text-secondary)'">
                <ng-container *ngIf="trajetZonesForm.value.zoneDestinationId; else placeholderDest">
                  {{ trajetZonesForm.value.zoneDestinationNom }}
                </ng-container>
                <ng-template #placeholderDest>Sélectionner une zone d'arrivée</ng-template>
              </span>
              <span style="color: var(--text-secondary);">▼</span>
            </div>

            <div *ngIf="showDestinationDropdown"
              style="position: absolute; top: 100%; left: 0; right: 0; background: white; border: 1px solid #e0e0e0; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); z-index: 1000; margin-top: 4px; max-height: 400px; display: flex; flex-direction: column;">
              <div style="padding: 12px; border-bottom: 1px solid #e0e0e0; background: #f8f9fa;">
                <input
                  type="text"
                  class="form-input"
                  [(ngModel)]="searchDestination"
                  [ngModelOptions]="{standalone: true}"
                  (input)="filterZones('destination')"
                  (click)="$event.stopPropagation()"
                  placeholder="🔍 Rechercher une zone..."
                  style="width: 100%;">
              </div>

              <div style="overflow-y: auto; max-height: 300px;">
                <div *ngIf="zonesDestinationFiltered.length === 0"
                  style="padding: 20px; text-align: center; color: var(--text-secondary);">
                  <span *ngIf="searchDestination.trim(); else noZonesDest">Aucune zone trouvée pour "{{ searchDestination }}"</span>
                  <ng-template #noZonesDest>Aucune zone disponible</ng-template>
                </div>
                <div *ngFor="let zone of zonesDestinationFiltered"
                  class="zone-option"
                  [class.selected]="trajetZonesForm.value.zoneDestinationId === zone.id"
                  (click)="selectZone('destination', zone)"
                  style="padding: 12px 16px; cursor: pointer; border-bottom: 1px solid #f0f0f0; transition: background-color 0.2s;">
                  <div style="font-weight: 600; color: #1f2937;">
                    {{ zone.nom }}
                  </div>
                  <div *ngIf="zone.description" style="font-size: 12px; color: #6b7280; margin-top: 2px;">
                    {{ zone.description }}
                  </div>
                  <span *ngIf="trajetZonesForm.value.zoneDestinationId === zone.id"
                    style="float: right; color: var(--primary-color); margin-top: -20px;">✓</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="form-section" style="position: relative; z-index: 1;">
      <h3 class="form-section-title">Tarification</h3>
      <div class="form-group">
        <label class="form-label">
          Distance estimée (km) *
          <span style="color: var(--text-secondary); font-size: 11px; font-weight: normal; display: block; margin-top: 4px;">
            Distance approximative entre les deux zones
          </span>
        </label>
        <input
          type="number"
          class="form-input"
          placeholder="Ex: 15"
          formControlName="distanceKm"
          min="0"
          step="0.1">
      </div>
    </div>

    <div class="form-section" style="position: relative; z-index: 1;">
      <h3 class="form-section-title">Observations (optionnel)</h3>
      <div class="form-group">
        <label class="form-label">Remarques</label>
        <textarea
          class="form-input"
          placeholder="Saisir les observations sur ce trajet ..."
          formControlName="observations"
          rows="4"></textarea>
      </div>
    </div>

    <div class="form-actions">
      <a [routerLink]="'/trajet/lister'" class="btn btn-secondary">Annuler</a>
      <button type="submit" class="btn btn-primary" [disabled]="chargement">
        {{ chargement ? 'Enregistrement...' : (estModeEdition ? 'Enregistrer les modifications' : 'Enregistrer le trajet') }}
      </button>
    </div>

    <app-spinner *ngIf="chargement"></app-spinner>
  </form>
</section>
